module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAECAYAAACdiF9iAAAAAXNSR0IArs4c6QAAAJpJREFUGBlVj9EBhDAIQ6HO5hq3/8ftUPMC1LtaoSZpgvn93DuvjMiMvFaEzvRcwk7XWd8Hn3Nr4f548CUPfFtbPUMJEXurKDC8VQQAuUNqy8IdONGyoBDyahmlgPspCnquOLAMJEFIGVb9mMtgYMxZGLlOvu7WfcI9YlXjaPsPSRqBDqTCavWcP4ZGm3+HqQAmcoyvvx6jY5gHWQ8/BXAsElUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Rectangle 4.png
// module id = JIWl
// module chunks = 1